// Contenu des modules Hygio présentés sur le site vitrine, regroupés par pôle.
// Aligné sur les fonctionnalités réelles de l'application (recap v2.5.0).
// Modifier ce fichier suffit pour changer les textes de la section "Fonctionnalités".
import {
  CalendarClock,
  Radio,
  CalendarCheck,
  Thermometer,
  SprayCan,
  PackageSearch,
  Trash2,
  Truck,
  Megaphone,
  Warehouse,
  LayoutGrid,
  BookUser,
  ShoppingCart,
  FileText,
  Calculator,
  CalendarRange,
  Vault,
  LayoutDashboard,
  GraduationCap,
  KeyRound,
  FileSpreadsheet,
} from "lucide-react";

const categories = [
  {
    name: "Équipe & planning",
    features: [
      {
        icon: CalendarClock,
        title: "Planning d'équipe",
        description:
          "Créez les plannings, gérez les créneaux, dupliquez une semaine type et exportez vers votre calendrier (iCal) en un clic.",
      },
      {
        icon: Radio,
        title: "Pointage & présence",
        description:
          "Badgeage entrée/sortie, historique complet et vue d'ensemble pour les managers : qui est en poste, en retard ou absent.",
      },
      {
        icon: CalendarCheck,
        title: "Congés & absences",
        description:
          "Vos employés font leur demande depuis l'appli, vous validez ou refusez en un geste — plus de mail ou de papier volant.",
      },
    ],
  },
  {
    name: "Conformité & hygiène",
    features: [
      {
        icon: Thermometer,
        title: "Températures",
        description:
          "Sondes connectées avec relevés automatiques ou saisie manuelle, historique par sonde, seuils d'alerte et détection de capteur muet.",
      },
      {
        icon: SprayCan,
        title: "Ménage",
        description:
          "Zones de nettoyage, planning de fréquence et validation des tâches effectuées, avec preuve à l'appui en cas de contrôle.",
      },
      {
        icon: PackageSearch,
        title: "Suivi des produits",
        description:
          "Fiches produits avec DLC/DLUO, recherche par code-barres, et alertes avant péremption. Marquez un produit \"consommé\" sans perdre l'historique.",
      },
      {
        icon: Trash2,
        title: "Produits jetés",
        description:
          "Enregistrez chaque produit jeté (motif, quantité, date) pour une traçabilité complète de vos pertes.",
      },
      {
        icon: Truck,
        title: "Réception livraison",
        description:
          "Contrôlez et enregistrez chaque livraison reçue, avec un historique complet par fournisseur.",
      },
      {
        icon: Megaphone,
        title: "Rappels produits",
        description:
          "Suivez les alertes de rappel officiel par lot identifié, et clôturez chaque alerte une fois traitée.",
      },
    ],
  },
  {
    name: "Stock & achats",
    features: [
      {
        icon: Warehouse,
        title: "Inventaire",
        description:
          "Catalogue d'articles avec prix et fournisseur associé, et sessions d'inventaire pour vos comptages de stock physique.",
      },
      {
        icon: LayoutGrid,
        title: "Stock",
        description:
          "Vue en grille de votre stock courant, avec ajustements rapides des quantités au fil de la journée.",
      },
      {
        icon: BookUser,
        title: "Fournisseurs",
        description:
          "Un carnet de contacts centralisé avec les jours de livraison de chaque fournisseur.",
      },
      {
        icon: ShoppingCart,
        title: "Commandes",
        description:
          "Passez et suivez vos commandes fournisseurs directement depuis l'application.",
      },
      {
        icon: FileText,
        title: "Factures",
        description:
          "Importez et retrouvez facilement vos factures fournisseurs, classées et consultables à tout moment.",
      },
    ],
  },
  {
    name: "Caisse & trésorerie",
    features: [
      {
        icon: Calculator,
        title: "Comptage de caisse",
        description:
          "Comptage des pièces et billets en fin de journée, avec historique et calcul automatique des écarts.",
      },
      {
        icon: CalendarRange,
        title: "Bilan de la semaine",
        description:
          "Total espèces et carte bancaire par jour, montant réellement déposé en banque, et écart conservé en caisse ou au coffre.",
      },
      {
        icon: Vault,
        title: "Coffre",
        description:
          "Suivi de la monnaie de réserve par dénomination, alertes de monnaie faible configurables, et historique de chaque mouvement.",
      },
    ],
  },
  {
    name: "Pilotage & administration",
    features: [
      {
        icon: LayoutDashboard,
        title: "Tableau de bord gérant",
        description:
          "Congés à valider, retards de pointage, coût des pertes du mois, valeur du stock et alertes du jour, réunis en un coup d'œil.",
      },
      {
        icon: GraduationCap,
        title: "Formation",
        description:
          "Catégories de formation et fiches produit détaillées, avec les étapes de préparation et les procédures à suivre.",
      },
      {
        icon: KeyRound,
        title: "Rôles & permissions",
        description:
          "Définissez des rôles personnalisés et contrôlez précisément quel membre de l'équipe voit quel module.",
      },
      {
        icon: FileSpreadsheet,
        title: "Export & journal d'activité",
        description:
          "Exportez toutes vos données en Excel, et retrouvez l'historique complet de qui a fait quoi, et quand.",
      },
    ],
  },
];

export default categories;
